module.exports = __webpack_public_path__ + "static/media/ca2.0895eee3.jpg";